import styled from "styled-components";

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 16px 24px;
`;

export const ContentTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const Title = styled.p`
  font-family: Inter;
  font-size: 18px;
  font-weight: 600;
  line-height: 21.78px;
  letter-spacing: -0.01em;
  text-align: left;
`;

export const Subtitle = styled.p`
  font-family: Inter;
  font-size: 14px;
  text-align: start;
`;

export const Row: any = styled.div`
  display: flex;
  gap: 32px;
  align-items: flex-end;
`;

export const Column = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: column;
`;

export const ButtonOutlined = styled.button`
  font-family: Inter;
  gap: 12px;
  display: flex;
  align-items: center;
  height: 40px;
  padding: 10px;
  background-color: #ffffff;
  border: 1px solid #2d5bff;
  border-radius: 8px;
  color: #2d5bff;
  cursor: pointer;
  :disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const ButtonRed = styled.button`
  font-family: Inter;
  gap: 12px;
  display: flex;
  align-items: center;
  height: 40px;
  padding: 10px;
  background-color: #f43636;
  border-radius: 8px;
  color: #ffffff;
  cursor: pointer;
  :disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const BodyTable = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 16px 24px;
`;

export const TitlePosition = styled.p`
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 19.36px;
  letter-spacing: -0.01em;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #333333;
`;

export const SubTitlePosition = styled.p`
  font-family: Inter;
  font-size: 16px;
  font-weight: 400;
  line-height: 19.36px;
  letter-spacing: -0.01em;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
`;

export const SpaceX: any = styled.div`
  width: ${(props: any) => props.space}px !important;
`;

export const SpaceY: any = styled.div`
  height: ${(props: any) => props.space}px !important;
`;

export const CardsContainer = styled.div`
  display: grid;

  grid-auto-flow: column;

  grid-template-rows: repeat(4, minmax(72px, auto));

  grid-template-columns: repeat(3, 1fr);

  gap: 16px;

  width: 100%;
  max-width: 1200px;
  margin-top: 24px;
`;

export const Card = styled.div`
  background-color: #ececec;
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  padding: 12px;
  max-height: 72px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const CardTitle = styled.p`
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  line-height: 14px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #646363;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const CardSubtitle = styled.p`
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #646363;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const DeleteButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: #eb5757;
  display: flex;
  align-items: center;

  &:hover {
    opacity: 0.8;
  }
`;

export const WarningTitle = styled.p`
  font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  line-height: 19.2px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #f43636;
`;

export const ButtonFade = styled.button`
  font-family: Inter;
  gap: 6px;
  display: flex;
  align-items: center;
  height: 40px;
  padding: 10px;
  border-radius: 8px;
  color: #ffffff;
  background: linear-gradient(268.28deg, #06d986 0%, #4a76fb 100%);
  cursor: pointer;
  :disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;
